/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Team_MemberInputs */

const en_admin_resources_resource_allocations_team_member = /** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team/Member`)
};

const de_admin_resources_resource_allocations_team_member = /** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team/Mitglied`)
};

const es_admin_resources_resource_allocations_team_member = /** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo/Miembro`)
};

const fr_admin_resources_resource_allocations_team_member = /** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe/membre`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_team_member = en_admin_resources_resource_allocations_team_member;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_team_member = en_admin_resources_resource_allocations_team_member;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_team_member = en_admin_resources_resource_allocations_team_member;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_team_member = en_admin_resources_resource_allocations_team_member;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Team_MemberInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_team_member = en_admin_resources_resource_allocations_team_member;

/**
* | output |
* | --- |
* | "Team/Member" |
*
* @param {Admin_Resources_Resource_Allocations_Team_MemberInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_team_member = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Team_MemberInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Team_MemberInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_team_member(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_team_member(inputs)
	return ro_admin_resources_resource_allocations_team_member(inputs)
});
export { admin_resources_resource_allocations_team_member as "admin.resources.resource_allocations.team_member" }